import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ENTITY_DETAIL_CLOSE } from 'constants/ActionTypes';
import { CAMPAIGNS, CAMPAIGNS_MARKETING } from 'constants/Entities';
import { getEntityFromString } from 'utils/getEntityFromString';

const CAMPAIGN_DETAIL_ENTITY_KEYS = new Set([CAMPAIGNS.entity, CAMPAIGNS_MARKETING.entity]);

const isPathWithinDetailRoute = (path, detailRoute) =>
    path === detailRoute || path.startsWith(`${detailRoute}/`);

/**
 * Closes campaign entity detail when navigating to another campaigns subsection
 * (e.g. marketing detail open → sales campaigns list) without route redirects.
 */
const useCloseStaleCampaignDetail = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const isDetailOpen = useSelector((state) => state.entityDetail.isOpen);
    const activeDetailEntity = useSelector((state) => {
        if (!state.entityDetail.isOpen) return null;
        const activeKey = state.entityDetail.active;
        return state.entityDetail[activeKey]?.entity ?? null;
    });

    useEffect(() => {
        if (!isDetailOpen || !activeDetailEntity) return;
        if (!CAMPAIGN_DETAIL_ENTITY_KEYS.has(activeDetailEntity)) return;

        const entityConfig = getEntityFromString(activeDetailEntity);
        const detailRoute = entityConfig?.route;
        const path = location.pathname || '';

        if (!detailRoute || isPathWithinDetailRoute(path, detailRoute)) {
            return;
        }

        dispatch({ type: ENTITY_DETAIL_CLOSE, purge: true });
    }, [activeDetailEntity, dispatch, isDetailOpen, location.pathname]);
};

export default useCloseStaleCampaignDetail;
